import { Pipe, PipeTransform } from '@angular/core';

/**
 * Strip HTML tags from a string
 */
@Pipe({
  name: 'stripHtml',
  standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }
    return value.replace(/<.*?>/g, '');
  }
}
